import { DefaultDataResponse } from '@bcraft-frontend-lib/core'
import dayjs from 'dayjs'

import { IBonusHistoryItemDTO, IConvertedBonusHistory } from './types/types'

export class BonusHistoryConverter {
  convertBonusHistory = (data: DefaultDataResponse<IBonusHistoryItemDTO>): IConvertedBonusHistory => {
    const bonusHistory =
      data?.results?.map(item => ({
        id: item.id,
        amount: +(+item.amount).toFixed(2),
        amountCurrency: item.amount_currency,
        date: dayjs(item.date).format('DD.MM.YYYY HH:mm'),
        type: item.type,
        bonusBalanceBefore: +(+item.bonus_balance_before).toFixed(2),
        bonusBalanceBeforeCurrency: item.bonus_balance_before_currency,
        bonusBalanceAfter: +(+item.bonus_balance_after).toFixed(2),
        bonusBalanceAfterCurrency: item.bonus_balance_after_currency,
      })) || []

    return {
      page: data.page,
      count: data.count,
      history: bonusHistory,
    }
  }
}
